import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { type } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../shared/services/commen/commen.services';
import { appService } from '../../../_services/app.service';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { environment } from '../../../../environments/environment';
import { Helpers } from '../../../helpers';
import { DatePipe } from '@angular/common';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { Http, Headers, RequestOptions, Response,ResponseContentType } from "@angular/http";

@Component({
  selector: 'app-print-report',
  templateUrl: './print-report.component.html',
  styleUrls: ['./print-report.component.scss']
})
export class PrintReportComponent implements OnInit {

  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any;
  SelectedCompanyLUT: any;
  SelectedCompantEmail: any;
  SelectedCompanyPhone: any;
  SelectedCompanyWebsite: any;
  SelectedCompanyOther: any;
  TenantUsers: any;
  CompanyIdForCookie: any;
  CompanyId: any;
  imgPath: any;
  SelectedCompanyLogoImg: any;
  SelectedCompanyMSME: any;
  ReportType: any;
  OrderId: any;
  ReportData: any;
  BookingId: any;
  OnlyHtmlView: boolean = false;
  divElements: any = "";
  static that: PrintReportComponent;
  SelectedCompanyLogoForPrem:any;
  billToParty: any = {};
  shipToParty: any = {};
  OrderDetails: any = [];
  tableDetails: any = [];
  exchangeRate: any = 0;
  totalWeight: any = 0;
  SelectedCompanyGSTCode;
  TablefooterData:any={};
  ParentCompanyName:any;
  PONo: any;
  PrintSKULabelData: any = [];
  currentDateTime: any = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
  userId: any;
  ParentUserId: any;
  hostUrl: any = environment.apiUrl;
  isInternational: boolean = false;
  stampImage = '/assets/app/media/img/logos/Stamp.png';
  isInvoiceOnlyHtmlView: boolean = false;
  PrintGateInPass: any = {};
  ConsingmentDetailsId:any;
  ConsignmentsData: any = [];

  constructor(
    private service: TranslateConfigService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private _appService: appService,
    private _activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private datepipe: DatePipe,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private anghttp: Http,
  ) {
    PrintReportComponent.that = this;
  }

  ngOnInit() {
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyLogoForPrem = environment.apiUrl + this.SelectedCompanyLogo;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.isInternational = JSON.parse(localStorage.getItem("SalesFlag"));
  }

  GetUserCompany() {
    var apiUrl =
      environment.apiUrl +
      "api/Company/GetUserCompanyDataByInvoice?id=" +
      this.CompanyId +
      "&param1=CompanyId";

    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.TenantUsers = response.data; //FOR DROPDOWN

        this.TenantUsers.forEach((element) => {
          this.CompanyIdForCookie = element;

          this.CompanyId = this.CompanyIdForCookie.Id;
          this.SelectedComapnyName =
            this.CompanyIdForCookie.SelectedComapnyName;
          this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
          this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
          this.SelectedCompantGSTIN =
            this.CompanyIdForCookie.SelectedCompantGSTIN;
          this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
          this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
          this.SelectedCompanyLUT = this.CompanyIdForCookie.SelectedCompanyLUT;
          this.SelectedCompantEmail =
            this.CompanyIdForCookie.SelectedComapnyEmail;
          this.SelectedCompanyPhone =
            this.CompanyIdForCookie.SelectedCompanyPhone;
          this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
          this.SelectedCompanyOther =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          console.log(this.SelectedCompanyOther, "SelectedCompanyOther");
          //$(".LoginCompanyLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);
          this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
          this.SelectedCompanyLogoImg =
            environment.apiUrl + this.SelectedCompanyLogo;
          //added by vithujan 22-06-2023
          this.SelectedCompanyMSME =
            this.CompanyIdForCookie.SelectedCompanyMSME;
          this.ParentCompanyName = this.CompanyIdForCookie.ParentCompanyName;
        });
      },
      (err) => {
        console.log(err);
        console.log("Error occured");
      }
    );
  }

  BillId: any;
  async PrintInvoice() {
    this.GetUserCompany();

    setTimeout(() => {
      if (this.ReportType == 'LTL Consignment') {
        this.PrintLTLConsignment();
      } else if (this.ReportType == 'Bills Detail') {
        this.GetPrintBillData(this.BillId, 'Detail');
      } else if (this.ReportType == 'Purchase Order Premvati') {
        this.PrintPurchaseOrder();
      } else if (this.ReportType == 'Print Sales Order') {
        this.LoadMakeToOrderAutoGeneratePO();
        this.LoadShowDiscount();
        this.PrintSalesOrderData();
      } else if (this.ReportType == 'Print Sticker') {
        if(this.OnlyHtmlView){
          this.PrintStickerOnlyHtmlView();
        }else{
          this.PrintSticker();
        }
      } else if(this.ReportType == 'Print Goods Outward Invoice'){
        this.LoadHideProductPricingColumns();
        this.PrintGoodsOutwardInvoice();
      } else if(this.ReportType == 'Print Goods Outward Pick Slip'){
        this.LoadHideProductPricingColumns();
        this.LoadMakeToOrderAutoGeneratePO();
        this.obv_Print_PickSlip();
      } else if(this.ReportType == 'Print Goods Outward Packing List'){
        this.LoadHideQtyinCasePackingList();
        this.LoadMakeToOrderAutoGeneratePO();
        this.LoadGotekPackingList();
        this.obv_Print_PackageList();
      } else if(this.ReportType == 'Print System AWB label'){
        this.Print_SystemAWBPrint();
      } else if(this.ReportType == 'Print Outward Summary Pick'){
        this.PrintPickSummary();
        // this.PrintPickSummaryDownLoad();
      } else if(this.ReportType == 'Print Outward Summary Pick Download'){
        // this.PrintPickSummary();
        this.PrintPickSummaryDownLoad();
      } else if(this.ReportType == 'Print Trip Sheet'){
        this.PrintTripSheet();
      } else if(this.ReportType == 'Print Truck Hire Challan with Cost'){
        this.PrintTruckHireChallanwithCost();
      }
    }, 2500);
  }

  PrintLTLConsignment() {
    this.ReportData = [];
    // var apiUrl =
    //   environment.apiUrl +
    //   "api/OrdersByVehicle/ol_orderLTLById?Id=" +
    //   this.OrderId + "&param1=" + this.BookingId;
    var apiUrl = "ol_orderLTLById?Id=" + this.OrderId + "&param1=" + this.BookingId;

    Helpers.setLoading(true);
    this._appService.Get('OrdersByVehicle', apiUrl).subscribe(
      (response: any) => {
        this.ReportData = response;


        setTimeout(() => {
          var divElements = document.getElementById("LTLConsignment");
          var $iframe: any = $("<iframe id='frame'>").appendTo("body");
          var printDiv = divElements.innerHTML;
          var win = $iframe[0].contentWindow || $iframe[0];

          $(win.document).ready(function () {
            // Inject CSS for print orientation
            var style = win.document.createElement('style');
            style.innerHTML = `
      @page {
        size: A4 portrait;
        margin: 0;
      }
      body {
        margin: 5mm;
      }
    `;
            win.document.head.appendChild(style);

            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 500);
            }, 100);
          });

          $iframe.contents().find("body").html(printDiv);
          $("#PrintInvoice").val("");
          Helpers.setLoading(false);
        }, 1000);
      }, error => {
        this.toastr.error('Error while getting data!', 'Error');
        Helpers.setLoading(false);
      });
  }

  PrintBillData: any = [];
  GetPrintBillData(Id, Type) {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId("Bills", "bill_GetPrintBillData", Id, Type)
      .subscribe(
        (response) => {
          this.PrintBillData = response;
          this.PrintBillData[0].BillDetailDataArray = [];
          let resObj: any = [];
          if (
            this.PrintBillData[0].BillDetailData != null &&
            this.PrintBillData[0].BillDetailData != ""
          ) {
            resObj = JSON.parse(this.PrintBillData[0].BillDetailData);
          }
          this.PrintBillData[0].BillDetailDataArray = resObj;
          //add by maaria on 20-10-2023
          if (this.PrintBillData[0].isDebit) {
            this.PrintBillData[0].BillDetailDataArray.forEach((item) => {
              item.Rate = item.Rate < 0 ? -item.Rate : item.Rate;
              item.Discount =
                item.Discount < 0 ? -item.Discount : item.Discount;
              item.Amount = item.Amount < 0 ? -item.Amount : item.Amount;
            });
          }
          //end
          if (Type == "Detail") {
            this.PrintDetailBill();
          }
          Helpers.setLoading(true);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          Helpers.setLoading(false);
        }
      );
  }

  PrintDetailBill() {
    setTimeout(() => {
      var divElements = document.getElementById("PrintDetailBill");
      var $iframe: any = $("<iframe id='frame'>").appendTo("body");
      var printDiv = divElements.innerHTML;
      var win = $iframe[0].contentWindow || $iframe[0];
      $(win.document).ready(function () {
        setTimeout(() => {
          win.window.print();
          setTimeout(() => {
            $iframe.remove();
          }, 200);
        });
      });
      $iframe.contents().find("body").html(printDiv);
      $("#se_PrintBill").val("");
      Helpers.setLoading(false);
    }, 100);
  }

  POProducts: any = [];
  TotalQty: any = 0;
  tyreData: any = [];
  TemplateData: any = [];
  BudgetHeader: any = [];
  BudgetMasterData: any = [];
  printOrderDetail: any = {};
  Centers: any = {};
  @Output() renderComplete = new EventEmitter<void>();
  PrintPurchaseOrder() {
    Helpers.setLoading(true);
    this._appService
      .GetById("OrdersByVehicle", "POProductsList", this.OrderId)
      .subscribe(
        (response) => {
          if(response.Table.length !== 0){
            this.printOrderDetail = response.Table[0]
          }
          this.TotalQty = 0;
          if(response.Table1.lenth !==0){
            this.tyreData = response.Table1;
            let i = 0;
            this.Centers = {};
            this.tyreData.forEach(function (value, prop, obj) {
              if (i == 0) {
                // PrintReportComponent.that.BudgetHeader = Object.getOwnPropertyNames(value);
                PrintReportComponent.that.BudgetHeader = Object.getOwnPropertyNames(value).filter(x => x !== 'ColorPalette' && x !== 'Rate' && x !== 'Amount'); 
              }

              // Loop through each column
              PrintReportComponent.that.BudgetHeader.forEach((col) => {
                // Skip these columns
                if (col === 'Product Name' || col === 'Packing') return;

                // Remove spaces from column name for consistent object keys (optional)
                const colKey = col.replace(/\s+/g, '');

                // Initialize total if not present
                if (!PrintReportComponent.that.Centers[colKey]) {
                  PrintReportComponent.that.Centers[colKey] = 0;
                }

                // Add to the total
                const qty = parseFloat(value[col]);
                if (!isNaN(qty)) {
                  PrintReportComponent.that.Centers[colKey] += qty;
                }
              });

              // var qty = value['Order Quantity (In Ctns)']
              // PrintReportComponent.that.TotalQty += parseFloat(qty);
              i++;
            });
          }

          setTimeout(() => {
            console.log('centers', this.Centers);
            var divElements = document.getElementById("PrintPurchaseOrderPremvati");
            this.divElements = divElements.innerHTML;
            this.renderComplete.emit();
            console.log(divElements.innerHTML);
            if (!this.OnlyHtmlView) {
              var $iframe: any = $("<iframe id='frame'>").appendTo("body");
              // var printDiv = divElements.innerHTML;
              // var printDiv = "<style type='text/css' media='print'> @page { margin: 0cm; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
              var printDiv = `
                            <html>
                              <head>
                                <title>Purchase Order</title>
                                <style type="text/css" media="print">
                                  @page {
                                    margin: 0cm 0cm 1cm 0cm;
                                    @bottom-right {
                                      content: "Page " counter(page) " of " counter(pages);
                                      font-size: 10pt;
                                      color: #555;
                                      padding-right: 2mm;
                                    }
                                  }
                                  body {
                                    font-family: Arial, sans-serif;
                                    -webkit-print-color-adjust: exact;
                                    print-color-adjust: exact;
                                  }
                                </style>
                              </head>
                              <body>
                                ${divElements.innerHTML}
                              </body>
                            </html>
                          `;

              var win = $iframe[0].contentWindow || $iframe[0];

              $(win.document).ready(function () {
                setTimeout(() => {
                  win.window.print();
                  setTimeout(() => {
                    $iframe.remove();
                  }, 500);
                });
              });

              $iframe.contents().find("body").html(printDiv);
              $("#PrintInvoice").val("");
            }
            Helpers.setLoading(false);
          }, 100);
          Helpers.setLoading(true);
        },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          Helpers.setLoading(false);
        }
      );

  }

  obvStickerData: any = [];
  PrintStickerOnlyHtmlView() {
    Helpers.setLoading(true);
    this._appService.GetById("so_GoodsOutward", "PrintSticker", this.OrderId).subscribe((response) => {
      this.obvStickerData = response;

      // Group data into chunks of 2
      this.groupedStickerData = [];
      for (let i = 0; i < this.obvStickerData.length; i += 2) {
        this.groupedStickerData.push(this.obvStickerData.slice(i, i + 2));
      }
      
      this.cdRef.detectChanges();

      setTimeout(() => {
        var divElements = document.getElementById("Print_StickerPremvati");
        this.divElements = divElements.innerHTML;
        this.renderComplete.emit();
        
        // if (!this.OnlyHtmlView) {
        //   var $iframe: any = $("<iframe id='frame'>").appendTo("body");
        //   // var printDiv = divElements.innerHTML;
        //   var printDiv = "<style type='text/css' media='print'>body {zoom: 90%; background-color: " + printColor + " } @page { size: 7in 4.5in;  margin: 0cm; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
        //   var win = $iframe[0].contentWindow || $iframe[0];

        //   $(win.document).ready(function () {
        //     setTimeout(() => {
        //       win.window.print();
        //       setTimeout(() => {
        //         $iframe.remove();
        //       }, 500);
        //     });
        //   });

        //   $iframe.contents().find("body").html(printDiv);
        //   $("#PrintInvoice").val("");
        // }
        Helpers.setLoading(false);
      }, 500);

      Helpers.setLoading(false);
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  removeSpaces(value: string): string {
    return value.replace(/\s+/g, '');
  }
  
  // PrintSticker() {
  //   Helpers.setLoading(true);
  //   this._appService.GetById("so_GoodsOutward", "PrintSticker", this.OrderId).subscribe((response) => {
  //     this.obvStickerData = response;
  //     // let printColor = response[0].ColorPalette;

  //     setTimeout(() => {
  //       var divElements = document.getElementById("Print_StickerPremvati");
  //       var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
  //       var printDiv = "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: 7in 4.6in;  margin: 0cm; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
  //       var win = $iframe[0].contentWindow || $iframe[0];
  //       console.log(divElements.innerHTML);
  //       $(win.document).ready(function () {
  //         setTimeout(() => {
  //           win.window.print();
  //           setTimeout(() => {
  //             $iframe.remove();
  //           }, 1000);
  //         });
  //       });
  //       $iframe.contents().find("body").html(printDiv);
  //       Helpers.setLoading(false);
  //     }, 300);

  //     Helpers.setLoading(false);
  //   },
  //     (err) => {
  //       this.toastr.error(err._body.replace(/"/g, ""), "error");
  //       Helpers.setLoading(false);
  //     }
  //   );
  // }


  groupedStickerData: any[] = [];

PrintSticker() {
  Helpers.setLoading(true);
  this.GetUserCompany();
  this._appService.GetById("so_GoodsOutward", "PrintSticker", this.OrderId).subscribe((response) => {
    // this.obvStickerData = response;
    this.obvStickerData = response.map(item => ({
        ...item,
        LogoPath: item.LogoPath ? environment.apiUrl + item.LogoPath : null
      }));
    // Group data into chunks of 2
    this.groupedStickerData = [];
    for (let i = 0; i < this.obvStickerData.length; i += 2) {
      this.groupedStickerData.push(this.obvStickerData.slice(i, i + 2));
    }

    setTimeout(() => {
      var divElements = document.getElementById("Print_StickerPremvati");
      // var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
      var printDiv = "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4; margin: 0; }</style><html ><head><title></title></head><body>" + divElements.innerHTML + "</body></html>";
      console.log(divElements.innerHTML);
      this.renderComplete.emit();
      var obj: any = {};
      obj.OrderId = this.OrderId;
      obj.PrintData = printDiv;
      obj.PONo = this.PONo;

      this._appService.Post("so_GoodsOutward", "DownloadStickerPdf", obj).subscribe((response) => {
        this.DownloadFile(response)
        Helpers.setLoading(false);
      },
        (err) => {
          // this.toastr.error(err._body.replace(/"/g, ""), "error");
          this.toastr.error("error while download", "error");
          Helpers.setLoading(false);
        }
      );

      // var win = $iframe[0].contentWindow || $iframe[0];
      // console.log(divElements.innerHTML);
      // $(win.document).ready(function () {
      //   setTimeout(() => {
      //     win.window.print();
      //     setTimeout(() => {
      //       $iframe.remove();
      //     }, 1000);
      //   });
      // });
      // $iframe.contents().find("body").html(printDiv);
      // Helpers.setLoading(false);
    }, 300);

  },
  (err) => {
    this.toastr.error(err._body.replace(/"/g, ""), "error");
    Helpers.setLoading(false);
  });
}

  PrintSalesOrderData() {
    Helpers.setLoading(true);
    this._appService.GetById("so_GoodsOutward", "obv_getSalseOrderData_Edit", this.OrderId).subscribe((response) => {
      setTimeout(() => {
        //BillTo Party
        this.billToParty.Customer = response.Table[0].CustomerName;
        this.billToParty.address = response.Table[0].PickupAddress;
        this.billToParty.city = response.Table[0].PickupCity;
        this.billToParty.state = response.Table[0].PickupState;
        this.billToParty.country = response.Table[0].PickupCountry;
        this.billToParty.pincode = response.Table[0].PickupPincode;
        this.billToParty.pickupLocationCode = response.Table[0].PickupLocationCode;
        this.billToParty.contactPerson = response.Table[0].PickUpContactPerson;
        this.billToParty.contactNumber = response.Table[0].PickUpContactNumber;
        this.billToParty.contactEmail = response.Table[0].PickUpContactEmail;
        this.billToParty.type = response.Table[0].CustomerType;
        this.billToParty.creditDays = response.Table[0].CreditCustomer;
        this.billToParty.salsePerson = response.Table[0].Salesperson;
        this.billToParty.referenceNo = response.Table[0].ReferenceNo;
        this.billToParty.orderStatus = response.Table[0].OrderStatus;

        this.billToParty.taxId = response.Table[0].Tax;
        this.billToParty.taxable = response.Table[0].Taxable;
        this.billToParty.isIGSTOnly = response.Table[0].isIGSTOnly;
        this.billToParty.exemptionReason = response.Table[0].ExemptionReason;
        this.billToParty.taxType = response.Table[0].Tax ? response.Table[0].Tax.substring(0, 2) == this.SelectedCompanyGSTCode ? 'Intra' : 'Inter' : '';


        // ShipTo Party
        this.shipToParty.ShipToName = response.Table[0].warehouseName;
        this.shipToParty.warehouseName = response.Table[0].warehouseName;
        this.shipToParty.DeliveryContactPerson = response.Table[0].DeliveryContactPerson;
        this.shipToParty.Floor = response.Table[0].Floor;
        this.shipToParty.LandMark = response.Table[0].LandMark;
        this.shipToParty.deliveryLocationCode = response.Table[0].DeliveryLocationCode;
        this.shipToParty.address = response.Table[0].DeliveryAddress;
        this.shipToParty.city = response.Table[0].DeliveryCity;
        this.shipToParty.state = response.Table[0].DeliveryState;
        this.shipToParty.country = response.Table[0].DeliveryCountry;
        this.shipToParty.pincode = response.Table[0].DeliveryPincode;
        this.shipToParty.contactPerson = response.Table[0].warehouseContactPerson;
        this.shipToParty.contactNumber = response.Table[0].DeliveryContactNumber;
        this.shipToParty.contactEmail = response.Table[0].DeliveryContactEmail;


        this.OrderDetails = response.Table[0];
        this.exchangeRate = response.Table[0].ExchangeRate;
        this.tableDetails = [];
        // this.tableDetails.footerData[0].qty = 0;
        // this.tableDetails.footerData[0].fulFilledQty = 0;
        // this.tableDetails.footerData[0].balanceQty = 0;
        // this.tableDetails.footerData[0].amount = 0;
        // this.tableDetails.footerData[1].amount = 0;
        // this.tableDetails.footerData[2].amount = 0;
        // this.tableDetails.footerData[3].amount = 0;
        // this.tableDetails.footerData[4].amount = 0;
        // this.tableDetails.footerData[5].amount = 0;
        // this.tableDetails.footerData[7].amount = 0;
        // this.tableDetails.footerData[6].amount = 0;
        // this.tableDetails.footerData[8].amount = 0;
        // this.tableDetails.footerData[9].amount = 0;
        this.TablefooterData={};

        this.TablefooterData.totalDiscount=0;
        this.TablefooterData.totalDiscount = response.Table[0].totalDiscount;
        
        this.TablefooterData.SalesDiscount=0;
        this.TablefooterData.GrossTotalAmount=0;
        this.TablefooterData.SalesDiscount=response.Table[0].SalesDiscount || 0;

        var ojjRes: any = [];
        this.totalWeight = 0;
        let totalqty = 0;
        let totalfulFilledQty = 0;
        let totalbalanceQty = 0;
        let totalamount = 0;
        let totalTaxableAmount = 0;
        let totalCGST = 0;
        let totalSGST = 0;
        let totalIGST = 0;
        let totalCESS = 0;
        let totalRoundoff = 0;
        let totalNetAmount = 0;
        let totalNetAmountinLocalCurrency = 0;
        // commented and Added by priya - 10/04/2026 - cn(PRIYA-APR26-005)
        // for (const item of response.Table1) {
        response.Table1.sort((a: any, b: any) => a.RowOrder - b.RowOrder).forEach((item: any) => {
          var obj: any = {};
          obj.productId = item.Product;
          obj.productPackingId = item.productPackingId;
          obj.productUIValue = item.productUIValue;
          obj.code = item.name;
          obj.name = item.ProductName;
          obj.description = item.ProductDesc;
          obj.unitId = item.Unit;
          obj.unit = item.UnitName;
          obj.weight = item.weight;
          obj.totalWeight = item.totalWeight;

          obj.caseSize = item.caseSize;
          obj.caseSizeList = [];
          if (item.caseSizeList != null) {
            obj.caseSizeList = JSON.parse(item.caseSizeList);
          } else {
            var objCaseSize: any = {};
            objCaseSize.value = item.caseSize;
            objCaseSize.name = item.caseSize;
            obj.caseSizeList.push(objCaseSize);
          }

          obj.qty = item.Qty;
          obj.fulFilledQty = item.AllocateQty;
          obj.balanceQty = item.BalanceQty;
          obj.caseQty = item.caseQty;

          obj.MRP = parseFloat(item.MRP).toFixed(2);
          obj.MRPList = [];
          if (item.MRPList != null) {
            obj.MRPList = JSON.parse(item.MRPList);
          } else {
            var objMRP: any = {};
            objMRP.value = item.MRP;
            objMRP.name = item.MRP;
            obj.MRPList.push(objMRP);
          }
          for (const item of obj.MRPList) {
            item.value = parseFloat(item.value).toFixed(2);
            item.name = parseFloat(item.name).toFixed(2);
          }

          obj.rate = parseFloat(item.UnitPrice).toFixed(2);
          if (this.isDiscountApply) {
            obj.amount = item.InvoiceAmount.toFixed(2);
          } else {
            obj.amount = item.netAmount.toFixed(2);
          }
          // obj.amount = item.netAmount.toFixed(2);
          obj.discount = item.Discount.toFixed(2);
          obj.netAmount = item.InvoiceAmount.toFixed(2);
          obj.taxRate = item.TaxRate;
          obj.taxId = item.taxId;
          obj.CessId = item.CessId;
          obj.CessRate = item.CessRate;
          obj.cgstAmount = item.cgstAmount;
          obj.sgstAmount = item.sgstAmount;
          obj.igstAmount = item.igstAmount;
          obj.cessAmount = item.cessAmount;
          obj.FinalShiptoName = item.FinalShiptoName;
          this.tableDetails.push(obj);

          totalqty = totalqty + obj.qty;
          totalfulFilledQty = totalfulFilledQty + obj.fulFilledQty;
          totalbalanceQty = totalbalanceQty + obj.balanceQty;
          totalamount = totalamount + parseFloat(obj.amount);

          totalTaxableAmount = totalTaxableAmount + parseFloat(obj.netAmount);
          totalCGST = totalCGST + parseFloat(obj.cgstAmount);
          totalSGST = totalSGST + parseFloat(obj.sgstAmount);
          totalIGST = totalIGST + parseFloat(obj.igstAmount);
          totalCESS = totalCESS + parseFloat(obj.cessAmount);

          totalNetAmount = totalTaxableAmount + totalCGST + totalSGST + totalIGST + totalCESS;

          totalRoundoff = Math.round(totalNetAmount) - totalNetAmount;

          totalNetAmount = Math.round(totalNetAmount);

          totalNetAmountinLocalCurrency = totalNetAmount * parseFloat(this.exchangeRate);

          this.totalWeight = (parseFloat(this.totalWeight) + parseFloat(obj.totalWeight)).toFixed(2);
        });

        this.TablefooterData.totalqty=totalqty;
        this.TablefooterData.totalfulFilledQty=totalfulFilledQty;
        this.TablefooterData.totalbalanceQty=totalbalanceQty;

        this.TablefooterData.totalamount=totalamount.toFixed(2);
        this.TablefooterData.totalTaxableAmount=totalTaxableAmount.toFixed(2);
        this.TablefooterData.totalCGST=totalCGST.toFixed(2);
        this.TablefooterData.totalSGST=totalSGST.toFixed(2);
        this.TablefooterData.totalIGST=totalIGST.toFixed(2);
        this.TablefooterData.totalCESS=totalCESS.toFixed(2);
        this.TablefooterData.totalNetAmount=totalNetAmount.toFixed(2);
        this.TablefooterData.totalRoundoff=totalRoundoff.toFixed(2);
        this.TablefooterData.totalNetAmountinLocalCurrency=totalNetAmountinLocalCurrency.toFixed(2);
        this.TablefooterData.GrossTotalAmount = this.TablefooterData.totalNetAmount - this.TablefooterData.SalesDiscount;
        this.TablefooterData.GrossTotalAmount=this.TablefooterData.GrossTotalAmount.toFixed(2);

        let totalCases = 0;
        let totalPcs = 0;

        // commented and Added by priya - 10/04/2026 - cn(PRIYA-APR26-005)
        // for (const item of response.Table1) {
        response.Table1.sort((a: any, b: any) => a.RowOrder - b.RowOrder).forEach((row: any) => {
          const qty = this.parseCaseQty(row.caseQty);
          totalCases += qty.cases;
          totalPcs += qty.pcs;
        });
        // End by priya
        this.TablefooterData.totalCaseQty = totalPcs > 0 ? `${totalCases} Case ${totalPcs} Pcs` : `${totalCases} Case`;

      }, 300);
      setTimeout(() => {
        var divElements = document.getElementById("Print_SalesOrder");
        var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
        var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
        var win = $iframe[0].contentWindow || $iframe[0];
        $(win.document).ready(function () {
            setTimeout(() => {
                win.window.print();
                setTimeout(() => {
                    $iframe.remove();
                }, 1000);
            });
        });
        $iframe.contents().find("body").html(printDiv);
        Helpers.setLoading(false);
      }, 300);
  
      Helpers.setLoading(false);
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  private parseCaseQty(qty: string): { cases: number; pcs: number } {
    qty = (qty || "").toLowerCase();
    let cases = 0, pcs = 0;

    let caseMatch = qty.match(/(\d+)\s*case/);
    let pcsMatch = qty.match(/(\d+)\s*(pcs|item)/);

    if (caseMatch) cases = parseInt(caseMatch[1], 10);
    if (pcsMatch) pcs = parseInt(pcsMatch[1], 10);

    return { cases, pcs };
  }

  MakeToOrderAutoGeneratePO: boolean = false;

  LoadMakeToOrderAutoGeneratePO() {
    this._appService.GetById("Common", "GetSystemSettingByName", "MakeToOrderAutoGeneratePO").subscribe((response) => {
      if (response == '1') {
        this.MakeToOrderAutoGeneratePO = true;
      } else {
        this.MakeToOrderAutoGeneratePO = false;
      }
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

  @ViewChild('barcodeWrapper') wrapper: ElementRef;
  barcodeWidth: any = 1;  // default
  barcodeHeight: any = 70;
  barcodeFontSize: any = 0;
  so_gi_GetDataForPrintSKULabel() {
    Helpers.setLoading(true);
    this._appService.GetById("so_GoodsOutward", "so_gi_GetDataForPrintSKULabel", this.OrderId).subscribe((response) => {
      this.DownloadFile(response)
      Helpers.setLoading(false);
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }


  so_gi_GetDataForPrintSKULabelQRCode() {
      Helpers.setLoading(true);
      this._appService.GetById("so_GoodsOutward", "so_gi_GetDataForPrintSKULabelQRCode", this.OrderId).subscribe((response) => {
        this.PrintSKULabelData = response;
  
        setTimeout(() => {
        var divElements = document.getElementById("Print_SKUQRCodeLabel");
        // const $iframe: any = $("<iframe id='frame1'>").appendTo("body");
  
        var printDiv = "<html><head><style>@page { size: 50mm 50mm; margin: 0 }</style></head><body>" + divElements.innerHTML + "</body></html>";
  
        var obj: any = {};
        obj.OrderId = this.OrderId;
        obj.PrintData = printDiv;
        obj.PONo = this.PONo;
  
        this._appService.Post("so_GoodsOutward", "DownloadLabelPdf", obj).subscribe((response) => {
          this.DownloadFile(response)
          Helpers.setLoading(false);
        },
          (err) => {
            // this.toastr.error(err._body.replace(/"/g, ""), "error");
            this.toastr.error("error while download", "error");
            Helpers.setLoading(false);
          }
        );
        }, 500);
  
        Helpers.setLoading(false);
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "error");
          Helpers.setLoading(false);
        }
      );
    }

  isDiscountApply: boolean = false;
  LoadShowDiscount() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ShowDiscount").subscribe((response) => {
      if (response == '1') {
        this.isDiscountApply = true;
      } else {
        this.isDiscountApply = false;
      }
      console.log('isDiscountApply>>',this.isDiscountApply);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  PrintSalesOrderHtmlOnly() {
    this.GetUserCompany();
    this.LoadMakeToOrderAutoGeneratePO();
    this.LoadShowDiscount();
    this._appService.GetById("so_GoodsOutward", "obv_getSalseOrderData_Edit", this.OrderId).subscribe((response) => {
      setTimeout(() => {
        this.billToParty.Customer = response.Table[0].CustomerName;
        this.billToParty.address = response.Table[0].PickupAddress;
        this.billToParty.city = response.Table[0].PickupCity;
        this.billToParty.state = response.Table[0].PickupState;
        this.billToParty.country = response.Table[0].PickupCountry;
        this.billToParty.pincode = response.Table[0].PickupPincode;
        this.billToParty.pickupLocationCode = response.Table[0].PickupLocationCode;
        this.billToParty.contactPerson = response.Table[0].PickUpContactPerson;
        this.billToParty.contactNumber = response.Table[0].PickUpContactNumber;
        this.billToParty.contactEmail = response.Table[0].PickUpContactEmail;
        this.billToParty.type = response.Table[0].CustomerType;
        this.billToParty.creditDays = response.Table[0].CreditCustomer;
        this.billToParty.salsePerson = response.Table[0].Salesperson;
        this.billToParty.referenceNo = response.Table[0].ReferenceNo;
        this.billToParty.orderStatus = response.Table[0].OrderStatus;

        this.billToParty.taxId = response.Table[0].Tax;
        this.billToParty.taxable = response.Table[0].Taxable;
        this.billToParty.isIGSTOnly = response.Table[0].isIGSTOnly;
        this.billToParty.exemptionReason = response.Table[0].ExemptionReason;
        this.billToParty.taxType = response.Table[0].Tax ? response.Table[0].Tax.substring(0, 2) == this.SelectedCompanyGSTCode ? 'Intra' : 'Inter' : '';


        // ShipTo Party
        this.shipToParty.ShipToName = response.Table[0].warehouseName;
        this.shipToParty.warehouseName = response.Table[0].warehouseName;
        this.shipToParty.DeliveryContactPerson = response.Table[0].DeliveryContactPerson;
        this.shipToParty.Floor = response.Table[0].Floor;
        this.shipToParty.LandMark = response.Table[0].LandMark;
        this.shipToParty.deliveryLocationCode = response.Table[0].DeliveryLocationCode;
        this.shipToParty.address = response.Table[0].DeliveryAddress;
        this.shipToParty.city = response.Table[0].DeliveryCity;
        this.shipToParty.state = response.Table[0].DeliveryState;
        this.shipToParty.country = response.Table[0].DeliveryCountry;
        this.shipToParty.pincode = response.Table[0].DeliveryPincode;
        this.shipToParty.contactPerson = response.Table[0].warehouseContactPerson;
        this.shipToParty.contactNumber = response.Table[0].DeliveryContactNumber;
        this.shipToParty.contactEmail = response.Table[0].DeliveryContactEmail;


        this.OrderDetails = response.Table[0];
        this.exchangeRate = response.Table[0].ExchangeRate;
        this.tableDetails = [];
        // this.tableDetails.footerData[0].qty = 0;
        // this.tableDetails.footerData[0].fulFilledQty = 0;
        // this.tableDetails.footerData[0].balanceQty = 0;
        // this.tableDetails.footerData[0].amount = 0;
        // this.tableDetails.footerData[1].amount = 0;
        // this.tableDetails.footerData[2].amount = 0;
        // this.tableDetails.footerData[3].amount = 0;
        // this.tableDetails.footerData[4].amount = 0;
        // this.tableDetails.footerData[5].amount = 0;
        // this.tableDetails.footerData[7].amount = 0;
        // this.tableDetails.footerData[6].amount = 0;
        // this.tableDetails.footerData[8].amount = 0;
        // this.tableDetails.footerData[9].amount = 0;
        this.TablefooterData={};

        this.TablefooterData.totalDiscount=0;
        this.TablefooterData.totalDiscount = response.Table[0].totalDiscount;
        
        this.TablefooterData.SalesDiscount=0;
        this.TablefooterData.GrossTotalAmount=0;
        this.TablefooterData.SalesDiscount=response.Table[0].SalesDiscount || 0;

        var ojjRes: any = [];
        this.totalWeight = 0;
        let totalqty = 0;
        let totalfulFilledQty = 0;
        let totalbalanceQty = 0;
        let totalamount = 0;
        let totalTaxableAmount = 0;
        let totalCGST = 0;
        let totalSGST = 0;
        let totalIGST = 0;
        let totalCESS = 0;
        let totalRoundoff = 0;
        let totalNetAmount = 0;
        let totalNetAmountinLocalCurrency = 0;
        // commented and Added by priya - 10/04/2026 - cn(PRIYA-APR26-005)
        // for (const item of response.Table1) {
        response.Table1.sort((a: any, b: any) => a.RowOrder - b.RowOrder).forEach((item: any) => {
          var obj: any = {};
          obj.productId = item.Product;
          obj.productPackingId = item.productPackingId;
          obj.productUIValue = item.productUIValue;
          obj.code = item.name;
          obj.name = item.ProductName;
          obj.description = item.ProductDesc;
          obj.unitId = item.Unit;
          obj.unit = item.UnitName;
          obj.weight = item.weight;
          obj.totalWeight = item.totalWeight;

          obj.caseSize = item.caseSize;
          obj.caseSizeList = [];
          if (item.caseSizeList != null) {
            obj.caseSizeList = JSON.parse(item.caseSizeList);
          } else {
            var objCaseSize: any = {};
            objCaseSize.value = item.caseSize;
            objCaseSize.name = item.caseSize;
            obj.caseSizeList.push(objCaseSize);
          }

          obj.qty = item.Qty;
          obj.fulFilledQty = item.AllocateQty;
          obj.balanceQty = item.BalanceQty;
          obj.caseQty = item.caseQty;

          obj.MRP = parseFloat(item.MRP).toFixed(2);
          obj.MRPList = [];
          if (item.MRPList != null) {
            obj.MRPList = JSON.parse(item.MRPList);
          } else {
            var objMRP: any = {};
            objMRP.value = item.MRP;
            objMRP.name = item.MRP;
            obj.MRPList.push(objMRP);
          }
          for (const item of obj.MRPList) {
            item.value = parseFloat(item.value).toFixed(2);
            item.name = parseFloat(item.name).toFixed(2);
          }

          obj.rate = parseFloat(item.UnitPrice).toFixed(2);
          if (this.isDiscountApply) {
            obj.amount = item.InvoiceAmount.toFixed(2);
          } else {
            obj.amount = item.netAmount.toFixed(2);
          }
          // obj.amount = item.netAmount.toFixed(2);
          obj.discount = item.Discount.toFixed(2);
          obj.netAmount = item.InvoiceAmount.toFixed(2);
          obj.taxRate = item.TaxRate;
          obj.taxId = item.taxId;
          obj.CessId = item.CessId;
          obj.CessRate = item.CessRate;
          obj.cgstAmount = item.cgstAmount;
          obj.sgstAmount = item.sgstAmount;
          obj.igstAmount = item.igstAmount;
          obj.cessAmount = item.cessAmount;
          obj.FinalShiptoName = item.FinalShiptoName;
          this.tableDetails.push(obj);

          totalqty = totalqty + obj.qty;
          totalfulFilledQty = totalfulFilledQty + obj.fulFilledQty;
          totalbalanceQty = totalbalanceQty + obj.balanceQty;
          totalamount = totalamount + parseFloat(obj.amount);

          totalTaxableAmount = totalTaxableAmount + parseFloat(obj.netAmount);
          totalCGST = totalCGST + parseFloat(obj.cgstAmount);
          totalSGST = totalSGST + parseFloat(obj.sgstAmount);
          totalIGST = totalIGST + parseFloat(obj.igstAmount);
          totalCESS = totalCESS + parseFloat(obj.cessAmount);

          totalNetAmount = totalTaxableAmount + totalCGST + totalSGST + totalIGST + totalCESS;

          totalRoundoff = Math.round(totalNetAmount) - totalNetAmount;

          totalNetAmount = Math.round(totalNetAmount);

          totalNetAmountinLocalCurrency = totalNetAmount * parseFloat(this.exchangeRate);

          this.totalWeight = (parseFloat(this.totalWeight) + parseFloat(obj.totalWeight)).toFixed(2);
        });

        this.TablefooterData.totalqty=totalqty;
        this.TablefooterData.totalfulFilledQty=totalfulFilledQty;
        this.TablefooterData.totalbalanceQty=totalbalanceQty;

        this.TablefooterData.totalamount=totalamount.toFixed(2);
        this.TablefooterData.totalTaxableAmount=totalTaxableAmount.toFixed(2);
        this.TablefooterData.totalCGST=totalCGST.toFixed(2);
        this.TablefooterData.totalSGST=totalSGST.toFixed(2);
        this.TablefooterData.totalIGST=totalIGST.toFixed(2);
        this.TablefooterData.totalCESS=totalCESS.toFixed(2);
        this.TablefooterData.totalNetAmount=totalNetAmount.toFixed(2);
        this.TablefooterData.totalRoundoff=totalRoundoff.toFixed(2);
        this.TablefooterData.totalNetAmountinLocalCurrency=totalNetAmountinLocalCurrency.toFixed(2);
        this.TablefooterData.GrossTotalAmount = this.TablefooterData.totalNetAmount - this.TablefooterData.SalesDiscount;
        this.TablefooterData.GrossTotalAmount=this.TablefooterData.GrossTotalAmount.toFixed(2);

        let totalCases = 0;
        let totalPcs = 0;

        response.Table1.sort((a: any, b: any) => a.RowOrder - b.RowOrder).forEach((row: any) => {
          const qty = this.parseCaseQty(row.caseQty);
          totalCases += qty.cases;
          totalPcs += qty.pcs;
        });

        this.TablefooterData.totalCaseQty = totalPcs > 0 ? `${totalCases} Case ${totalPcs} Pcs` : `${totalCases} Case`;

      }, 300);
      setTimeout(() => {
        var divElements = document.getElementById("Print_SalesOrder");
        this.divElements = divElements.innerHTML;
        this.renderComplete.emit();
      }, 300);
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      }
    );
  }

  HideMfgExpDateOnInward: boolean = false;
  LoadEnableMfgExpDateOnInward() {
    this._appService
      .GetById("Common", "GetSystemSettingByName", "HideMfgExpDateOnInward")
      .subscribe(
        (response) => {
          if (response == "1") {
            this.HideMfgExpDateOnInward = true;
          } else {
            this.HideMfgExpDateOnInward = false;
          }
          console.log(
            "HideMfgExpDateOnInward>>",
            this.HideMfgExpDateOnInward,
          );
        },
        (err) => {
          this.toastr.error(
            "Error occurred while fetching Status data !",
            "error",
          );
        },
      );
  }

  obvPrintData: any = [];
  PrintGoodsOutwardInvoice() {
    Helpers.setLoading(true);

    const isHtmlOnly = this.isInvoiceOnlyHtmlView === true;
    this.isInternational = JSON.parse(localStorage.getItem("SalesFlag"));
    this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
    const payload = {
      UserId: this.ParentUserId,
      CompanyId: this.CompanyId,
      OrderIds: this.OrderId,
      ConsignmentDetailId: null,
      InvoiceNo: ''
    };
    this._appService.so_gow_GetInvoiceDataForPrintBulk(payload).subscribe((response) => {

      this.obvPrintData = this.getUniquePrintRows(response.Table || []);

      for (const item of this.obvPrintData) {
        item.InvoiceDetails = [];
        if (item.invoiceDataList != null) {
          item.InvoiceDetails = JSON.parse(item.invoiceDataList);
          // Added by priya - 13/04/2026 - cn(PRIYA-APR26-005)
          item.InvoiceDetails.sort((a: any, b: any) => {
            return (a.RowOrder || 0) - (b.RowOrder || 0);
          });
        }

        item.ComponentRate = [];
        if (item.invoiceTaxDetailDataList != null) {
          item.ComponentRate = JSON.parse(item.invoiceTaxDetailDataList);
        }

        item.BankAccountDetails = [];
        if (item.accountDetailDataList != null) {
          item.BankAccountDetails = JSON.parse(item.accountDetailDataList);
        }
      }

      const formatNumberWithCommas = (value: number | string): string => {
        return new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
      };

      for (const item of this.obvPrintData) {
        item.GrossTotalAmount = 0;
        item.DiscountAmount = 0;
        item.TaxableAmount = 0;
        item.totalSgstAmount = 0;
        item.totalCgstAmount = 0;
        item.totalIgstAmount = 0;
        item.totalCessAmount = 0;
        item.FinalAmount = 0;
        item.FinalAmountCurrencyWise = 0;
        item.TotalPcs = 0;
        let totalCases = 0;
        let totalPcs = 0;
        for (const itemPrd of item.InvoiceDetails) {
          itemPrd.child_product_list = [];
          if (itemPrd.child_product_data != null) {
            itemPrd.child_product_list = JSON.parse(itemPrd.child_product_data);
          }

          item.GrossTotalAmount = parseFloat(parseFloat(item.GrossTotalAmount) + itemPrd.netAmount).toFixed(2);
          item.DiscountAmount = parseFloat(parseFloat(item.DiscountAmount) + itemPrd.Discount).toFixed(2);
          item.TaxableAmount = parseFloat(parseFloat(item.TaxableAmount) + itemPrd.InvoiceAmount).toFixed(2);
          item.totalSgstAmount = parseFloat(parseFloat(item.totalSgstAmount) + itemPrd.sgstAmount).toFixed(2);
          item.totalCgstAmount = parseFloat(parseFloat(item.totalCgstAmount) + itemPrd.cgstAmount).toFixed(2);
          item.totalIgstAmount = parseFloat(parseFloat(item.totalIgstAmount) + itemPrd.igstAmount).toFixed(2);
          item.totalCessAmount = parseFloat(parseFloat(item.totalCessAmount) + itemPrd.cessAmount).toFixed(2);
          item.FinalAmount = parseFloat(parseFloat(item.FinalAmount) + itemPrd.FinalAmount).toFixed(2);
          item.TotalPcs = parseFloat(parseFloat(item.TotalPcs) + itemPrd.Qty).toFixed(2);
          const match = itemPrd.caseQty.match(/(\d+)\s*Case(?:\s+(\d+)\s*Pcs)?/);
          if (match) {
            totalCases += parseInt(match[1], 10);
            totalPcs += match[2] ? parseInt(match[2], 10) : 0;
          }
        }

        const casesFromPcs = Math.floor(totalPcs / 12);
        totalCases += casesFromPcs;
        totalPcs = totalPcs % 12;

        item.TotalQtys = `${totalCases} Case${totalCases > 1 ? 's' : ''}${totalPcs > 0 ? ` ${totalPcs} Pcs` : ''}`;


        item.FinalAmount = Math.round(item.FinalAmount);
        item.NewGrandTotalAmount = 0
        item.NewGrandTotalAmount = ((Number(item.FinalAmount) || 0) - (Number(item.SalesDiscount) || 0) + (Number(item.ShippingCharges) || 0)).toFixed(2);

        item.FinalAmountCurrencyWise = (parseFloat(item.FinalAmount) * parseFloat(item.ExchangeRate)).toFixed(2);

        item.GrossTotalAmount = formatNumberWithCommas(item.GrossTotalAmount);
        item.NewGrandTotalAmount = formatNumberWithCommas(item.NewGrandTotalAmount);
        item.DiscountAmount = formatNumberWithCommas(item.DiscountAmount);
        item.TaxableAmount = formatNumberWithCommas(item.TaxableAmount);
        item.totalSgstAmount = formatNumberWithCommas(item.totalSgstAmount);
        item.totalCgstAmount = formatNumberWithCommas(item.totalCgstAmount);
        item.totalIgstAmount = formatNumberWithCommas(item.totalIgstAmount);
        item.totalCessAmount = formatNumberWithCommas(item.totalCessAmount);
        item.FinalAmount = formatNumberWithCommas(item.FinalAmount);
        item.FinalAmountCurrencyWise = formatNumberWithCommas(item.FinalAmountCurrencyWise);
        item.TotalPcs = formatNumberWithCommas(item.TotalPcs);

        item.TotalTaxablevalue = 0;
        item.ComponentToTalIGST = 0;
        item.ComponentToTalCGST = 0;
        item.ComponentToTalSGST = 0;
        item.ComponentToTalGST = 0;
        for (const itemCr of item.ComponentRate) {
          item.TotalTaxablevalue = parseFloat(parseFloat(item.TotalTaxablevalue) + itemCr.TaxableValue).toFixed(2);
          item.ComponentToTalIGST = parseFloat(parseFloat(item.ComponentToTalIGST) + itemCr.IGSTRATE).toFixed(2);
          item.ComponentToTalCGST = parseFloat(parseFloat(item.ComponentToTalCGST) + itemCr.CGSTRATE).toFixed(2);
          item.ComponentToTalSGST = parseFloat(parseFloat(item.ComponentToTalSGST) + itemCr.SGSTRATE).toFixed(2);
        }
        item.ComponentToTalGST = (parseFloat(item.ComponentToTalIGST) + parseFloat(item.ComponentToTalCGST) + parseFloat(item.ComponentToTalSGST)).toFixed(2);


        item.TotalTaxablevalue = formatNumberWithCommas(item.TotalTaxablevalue);
        item.ComponentToTalIGST = formatNumberWithCommas(item.ComponentToTalIGST);
        item.ComponentToTalCGST = formatNumberWithCommas(item.ComponentToTalCGST);
        item.ComponentToTalSGST = formatNumberWithCommas(item.ComponentToTalSGST);
        item.ComponentToTalGST = formatNumberWithCommas(item.ComponentToTalGST);
      }

      setTimeout(() => {
        var divElements = document.getElementById("Outward_PrintInvoice_PDF");

        if (!divElements) {
          this.isInvoiceOnlyHtmlView = false;
          Helpers.setLoading(false);
          return;
        }

        this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
        this.divElements = divElements.innerHTML;
        this.renderComplete.emit();
        console.log(divElements.innerHTML);

        if(isHtmlOnly === false){
          var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
          var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 1000);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          this.isInvoiceOnlyHtmlView = false;
          Helpers.setLoading(false);
        }
      }, 300);

      this.isInvoiceOnlyHtmlView = false;
      Helpers.setLoading(false);
    },
      (err) => {
        this.isInvoiceOnlyHtmlView = false;
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  private getUniquePrintRows(rows: any[]): any[] {
    const rowMap = new Map<string, any>();
    (rows || []).forEach(row => {
      if (!row || !row.Id) {
        return;
      }

      const existing = rowMap.get(row.Id);
      if (!existing || this.shouldUsePrintRow(row, existing)) {
        rowMap.set(row.Id, row);
      }
    });
    return Array.from(rowMap.values());
  }

  private shouldUsePrintRow(candidate: any, existing: any): boolean {
    const candidateHasDetails = this.hasPrintableInvoiceDetails(candidate);
    const existingHasDetails = this.hasPrintableInvoiceDetails(existing);

    if (candidateHasDetails !== existingHasDetails) {
      return candidateHasDetails;
    }

    return this.getPrintInvoiceTime(candidate.InvoiceDate) >= this.getPrintInvoiceTime(existing.InvoiceDate);
  }

  private hasPrintableInvoiceDetails(row: any): boolean {
    if (!row || !row.invoiceDataList) {
      return false;
    }

    try {
      const details = JSON.parse(row.invoiceDataList);
      return Array.isArray(details) && details.length > 0;
    } catch (e) {
      return false;
    }
  }

  private getPrintInvoiceTime(invoiceDate: any): number {
    if (!invoiceDate) {
      return 0;
    }

    const dateText = invoiceDate.toString().trim();
    const dateMatch = dateText.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/);
    if (dateMatch) {
      const monthIndex = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'].indexOf(dateMatch[2].toLowerCase());
      if (monthIndex >= 0) {
        return new Date(Number(dateMatch[3]), monthIndex, Number(dateMatch[1])).getTime();
      }
    }

    const parsedDate = Date.parse(dateText);
    return isNaN(parsedDate) ? 0 : parsedDate;
  }

  HideProductPricingColumns: boolean = false;
  LoadHideProductPricingColumns() {
    this._appService.GetById("Common", "GetSystemSettingByName", "HideProductPricingColumns").subscribe((response) => {
      if (response == '1') {
        this.HideProductPricingColumns = false;
      } else {
        this.HideProductPricingColumns = false;
      }
      console.log('HideProductPricingColumns>>', this.HideProductPricingColumns);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  formatAmount(amount: string | number): number {
    return Number(amount.toString().replace(/,/g, '').split('.')[0]);
  }

   convertToWords(num: number): string {
    const ones = [
      '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
      'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen',
      'eighteen', 'nineteen'
    ];
    const tens = [
      '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
    ];
    const scales = ['crore', 'lakh', 'thousand', 'hundred', ''];

    const scaleValues = [10000000, 100000, 1000, 100, 1];

    if (num === 0) {
      return 'zero';
    }

    let words = '';
    for (let i = 0; i < scaleValues.length; i++) {
      const unitValue = Math.floor(num / scaleValues[i]);
      if (unitValue > 0) {
        num %= scaleValues[i];
        words += `${this.getWords(unitValue, ones, tens)} ${scales[i]} `;
      }
    }

    const decimal = Math.floor((num % 1) * 100);
    if (decimal > 0) {
      words += `and ${this.convertToWords(decimal)} paise`;
    }

    return this.toSentenceCase(words.trim());
  }

   private getWords(value: number, ones: string[], tens: string[]): string {
    if (value < 20) {
      return ones[value];
    } else {
      const tensValue = Math.floor(value / 10);
      const onesValue = value % 10;
      return `${tens[tensValue]} ${ones[onesValue]}`.trim();
    }
  }

  private toSentenceCase(words: string): string {
    return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
  }

  PickAwaySlipData: any = [];
  obv_Print_PickSlip() {
    this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
    Helpers.setLoading(true);
    var obj: any = {};
    obj.user_id = this.ParentUserId;
    obj.order_id = this.OrderId;
    this._appService.Post("so_GoodsOutward", "so_gow_GetDataForPrintPickSlip", obj).subscribe(
      (response) => {
        this.PickAwaySlipData = response;

        for (const item of this.PickAwaySlipData) {
          item.ProductData = null;
          if (item.ProductDataList != null) {
            item.ProductData = JSON.parse(item.ProductDataList);
          }
        }

        setTimeout(() => {
          var divElements = document.getElementById("Outward_PrintPickSlip_PDF");
          this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
          var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
          var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
          console.log('Outward_PrintPickSlip_PDF',divElements.innerHTML);
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 1000);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          Helpers.setLoading(false);
        }, 300);

        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  PackageListData: any = [];
  obv_Print_PackageList() {
    this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
    Helpers.setLoading(true);
    var obj: any = {};
    obj.userId = this.ParentUserId;
    obj.orderId = null;
    obj.MultiOrderId = this.OrderId;
    obj.companyId = this.CompanyId;
    this._appService.Post("so_GoodsOutward", "GetOutwardPackageListData", obj).subscribe(
      (response) => {
        this.PackageListData = response.Table;

        for (const item of this.PackageListData) {
          item.InvoiceDetails = null;
          if (item.OrderProductList != null) {
            item.InvoiceDetails = JSON.parse(item.OrderProductList);
            
            const sortedData = [...(item.InvoiceDetails || [])].sort(
              (a: any, b: any) => (a.RowOrder || 0) - (b.RowOrder || 0)
            );
            item.InvoiceDetails = sortedData;

            item.totalQty = 0;
            item.totalInvoiceAmount = 0;
            for (const ele of item.InvoiceDetails) {
              item.totalQty = item.totalQty + ele.Qty;
              ele.Qty = parseFloat(ele.Qty).toFixed(2);
              item.totalInvoiceAmount = (Number(item.totalInvoiceAmount) || 0) + (Number(ele.InvoiceAmount) || 0);
            }
            item.totalQty = parseFloat(item.totalQty).toFixed(2);
            item.totalInvoiceAmount = parseFloat(item.totalInvoiceAmount).toFixed(2);
          }
        }

        // this.PackageListData[0].InvoiceDetails = [];
        // const sortedData = [...(response.Table1 || [])].sort(
        //   (a: any, b: any) => (a.RowOrder || 0) - (b.RowOrder || 0)
        // );
        // this.PackageListData[0].InvoiceDetails = sortedData;

        // this.PackageListData[0].totalQty = 0;
        // this.PackageListData[0].totalInvoiceAmount = 0;
        // for (const item of this.PackageListData[0].InvoiceDetails) {
        //   this.PackageListData[0].totalQty = this.PackageListData[0].totalQty + item.Qty;
        //   item.Qty = parseFloat(item.Qty).toFixed(2);
        //   this.PackageListData[0].totalInvoiceAmount = (Number(this.PackageListData[0].totalInvoiceAmount) || 0) + (Number(item.InvoiceAmount) || 0);
        // }
        // this.PackageListData[0].totalQty = parseFloat(this.PackageListData[0].totalQty).toFixed(2);
        // this.PackageListData[0].totalInvoiceAmount = parseFloat(this.PackageListData[0].totalInvoiceAmount).toFixed(2);


        setTimeout(() => {
          var divElements = document.getElementById("Outward_PrintPackingList_PDF");
          this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
          console.log('Outward_PrintPackingList_PDF',divElements.innerHTML);
          var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
          var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 1000);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          Helpers.setLoading(false);
        }, 300);

        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  
  HideQtyinCasePackingList: boolean = false;
  LoadHideQtyinCasePackingList() {
    this._appService.GetById("Common", "GetSystemSettingByName", "HideQtyinCasePackingList").subscribe((response) => {
      if (response == '1') {
        this.HideQtyinCasePackingList = true;
      } else {
        this.HideQtyinCasePackingList = false;
      }
      console.log('HideQtyinCasePackingList>>', this.HideQtyinCasePackingList);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  
  GotekPackingList: boolean = false;
  LoadGotekPackingList() {
    this._appService.GetById("Common", "GetSystemSettingByName", "GotekPackingList").subscribe((response) => {
      if (response == '1') {
        this.GotekPackingList = true;
      } else {
        this.GotekPackingList = false;
      }
      console.log('GotekPackingList>>', this.GotekPackingList);
    },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      });
  }

  private async PrintInvoiceAndPickSlipOrderWise() {
    const orderIds = this.OrderId.toString().split(",").filter(x => x);

    for (const orderId of orderIds) {
      this.OrderId = orderId;

      await this.PrintGoodsOutwardInvoice();
      await this.delay(1000);

      await this.obv_Print_PickSlip();
      await this.delay(1000);
    }
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async callPrintMethod() {
    this.GetUserCompany();

    setTimeout(async () => {
     if (this.ReportType == "Print Goods Outward Invoice And Pick Slip") {
        this.LoadHideProductPricingColumns();
        this.LoadMakeToOrderAutoGeneratePO();
        await this.PrintInvoiceAndPickSlipInSinglePrint();
      }
    }, 2500);
  }

  async PrintInvoiceAndPickSlipInSinglePrint() {
    Helpers.setLoading(true);

    const oldOrderId = this.OrderId;
    const orderIds = this.OrderId
      .toString()
      .split(",")
      .map(x => x.trim())
      .filter(x => x);

    let finalPrintHtml = "";

    try {
      this.LoadHideProductPricingColumns();
      this.LoadMakeToOrderAutoGeneratePO();

      for (const orderId of orderIds) {
        this.OrderId = orderId;

        await this.LoadGoodsOutwardInvoiceDataOnly();
        await this.waitForHtmlRender(500);

        const invoiceDiv = document.getElementById("Outward_PrintInvoice_PDF");
        if (invoiceDiv && invoiceDiv.innerHTML.trim() != "") {
          finalPrintHtml += invoiceDiv.innerHTML;
        }

        await this.LoadGoodsOutwardPickSlipDataOnly();
        await this.waitForHtmlRender(500);

        const pickSlipDiv = document.getElementById("Outward_PrintPickSlip_PDF");
        if (pickSlipDiv && pickSlipDiv.innerHTML.trim() != "") {
          finalPrintHtml += pickSlipDiv.innerHTML;
        }

      }

      this.OrderId = oldOrderId;

      setTimeout(() => {
        this.PrintCombinedHtml(finalPrintHtml);
        Helpers.setLoading(false);
      }, 300);

    } catch (err) {
      this.OrderId = oldOrderId;
      Helpers.setLoading(false);
      this.toastr.error("Error while printing invoice and pick slip", "error");
    }
  }

  private LoadGoodsOutwardInvoiceDataOnly(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.isInternational = JSON.parse(localStorage.getItem("SalesFlag"));
      this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");

      const payload = {
        UserId: this.ParentUserId,
        CompanyId: this.CompanyId,
        OrderIds: this.OrderId,
        ConsignmentDetailId: null,
        InvoiceNo: ""
      };

      this._appService.so_gow_GetInvoiceDataForPrintBulk(payload).subscribe(
        response => {
          this.obvPrintData = this.getUniquePrintRows(response.Table || []);

          for (const item of this.obvPrintData) {
            item.InvoiceDetails = [];
            if (item.invoiceDataList != null) {
              item.InvoiceDetails = JSON.parse(item.invoiceDataList);
              item.InvoiceDetails.sort((a: any, b: any) => {
                return (a.RowOrder || 0) - (b.RowOrder || 0);
              });
            }

            item.ComponentRate = [];
            if (item.invoiceTaxDetailDataList != null) {
              item.ComponentRate = JSON.parse(item.invoiceTaxDetailDataList);
            }

            item.BankAccountDetails = [];
            if (item.accountDetailDataList != null) {
              item.BankAccountDetails = JSON.parse(item.accountDetailDataList);
            }
          }

          const formatNumberWithCommas = (value: number | string): string => {
            return new Intl.NumberFormat("en-IN", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(Number(value));
          };

          for (const item of this.obvPrintData) {
            item.GrossTotalAmount = 0;
            item.DiscountAmount = 0;
            item.TaxableAmount = 0;
            item.totalSgstAmount = 0;
            item.totalCgstAmount = 0;
            item.totalIgstAmount = 0;
            item.totalCessAmount = 0;
            item.FinalAmount = 0;
            item.FinalAmountCurrencyWise = 0;
            item.TotalPcs = 0;

            let totalCases = 0;
            let totalPcs = 0;

            for (const itemPrd of item.InvoiceDetails) {
              itemPrd.child_product_list = [];
              if (itemPrd.child_product_data != null) {
                itemPrd.child_product_list = JSON.parse(itemPrd.child_product_data);
              }
              item.GrossTotalAmount = parseFloat(parseFloat(item.GrossTotalAmount) + itemPrd.netAmount).toFixed(2);
              item.DiscountAmount = parseFloat(parseFloat(item.DiscountAmount) + itemPrd.Discount).toFixed(2);
              item.TaxableAmount = parseFloat(parseFloat(item.TaxableAmount) + itemPrd.InvoiceAmount).toFixed(2);
              item.totalSgstAmount = parseFloat(parseFloat(item.totalSgstAmount) + itemPrd.sgstAmount).toFixed(2);
              item.totalCgstAmount = parseFloat(parseFloat(item.totalCgstAmount) + itemPrd.cgstAmount).toFixed(2);
              item.totalIgstAmount = parseFloat(parseFloat(item.totalIgstAmount) + itemPrd.igstAmount).toFixed(2);
              item.totalCessAmount = parseFloat(parseFloat(item.totalCessAmount) + itemPrd.cessAmount).toFixed(2);
              item.FinalAmount = parseFloat(parseFloat(item.FinalAmount) + itemPrd.FinalAmount).toFixed(2);
              item.TotalPcs = parseFloat(parseFloat(item.TotalPcs) + itemPrd.Qty).toFixed(2);

              const match = itemPrd.caseQty ? itemPrd.caseQty.match(/(\d+)\s*Case(?:\s+(\d+)\s*Pcs)?/) : null;
              if (match) {
                totalCases += parseInt(match[1], 10);
                totalPcs += match[2] ? parseInt(match[2], 10) : 0;
              }
            }

            const casesFromPcs = Math.floor(totalPcs / 12);
            totalCases += casesFromPcs;
            totalPcs = totalPcs % 12;

            item.TotalQtys = `${totalCases} Case${totalCases > 1 ? "s" : ""}${totalPcs > 0 ? ` ${totalPcs} Pcs` : ""}`;

            item.FinalAmount = Math.round(item.FinalAmount);
            item.NewGrandTotalAmount = ((Number(item.FinalAmount) || 0) - (Number(item.SalesDiscount) || 0) + (Number(item.ShippingCharges) || 0)).toFixed(2);
            item.FinalAmountCurrencyWise = (parseFloat(item.FinalAmount) * parseFloat(item.ExchangeRate)).toFixed(2);

            item.GrossTotalAmount = formatNumberWithCommas(item.GrossTotalAmount);
            item.NewGrandTotalAmount = formatNumberWithCommas(item.NewGrandTotalAmount);
            item.DiscountAmount = formatNumberWithCommas(item.DiscountAmount);
            item.TaxableAmount = formatNumberWithCommas(item.TaxableAmount);
            item.totalSgstAmount = formatNumberWithCommas(item.totalSgstAmount);
            item.totalCgstAmount = formatNumberWithCommas(item.totalCgstAmount);
            item.totalIgstAmount = formatNumberWithCommas(item.totalIgstAmount);
            item.totalCessAmount = formatNumberWithCommas(item.totalCessAmount);
            item.FinalAmount = formatNumberWithCommas(item.FinalAmount);
            item.FinalAmountCurrencyWise = formatNumberWithCommas(item.FinalAmountCurrencyWise);
            item.TotalPcs = formatNumberWithCommas(item.TotalPcs);

            item.TotalTaxablevalue = 0;
            item.ComponentToTalIGST = 0;
            item.ComponentToTalCGST = 0;
            item.ComponentToTalSGST = 0;
            item.ComponentToTalGST = 0;

            for (const itemCr of item.ComponentRate) {
              item.TotalTaxablevalue = parseFloat(parseFloat(item.TotalTaxablevalue) + itemCr.TaxableValue).toFixed(2);
              item.ComponentToTalIGST = parseFloat(parseFloat(item.ComponentToTalIGST) + itemCr.IGSTRATE).toFixed(2);
              item.ComponentToTalCGST = parseFloat(parseFloat(item.ComponentToTalCGST) + itemCr.CGSTRATE).toFixed(2);
              item.ComponentToTalSGST = parseFloat(parseFloat(item.ComponentToTalSGST) + itemCr.SGSTRATE).toFixed(2);
            }

            item.ComponentToTalGST = (
              parseFloat(item.ComponentToTalIGST) +
              parseFloat(item.ComponentToTalCGST) +
              parseFloat(item.ComponentToTalSGST)
            ).toFixed(2);

            item.TotalTaxablevalue = formatNumberWithCommas(item.TotalTaxablevalue);
            item.ComponentToTalIGST = formatNumberWithCommas(item.ComponentToTalIGST);
            item.ComponentToTalCGST = formatNumberWithCommas(item.ComponentToTalCGST);
            item.ComponentToTalSGST = formatNumberWithCommas(item.ComponentToTalSGST);
            item.ComponentToTalGST = formatNumberWithCommas(item.ComponentToTalGST);
          }

          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }

  private LoadGoodsOutwardPickSlipDataOnly(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");

      const obj: any = {};
      obj.user_id = this.ParentUserId;
      obj.order_id = this.OrderId;

      this._appService.Post("so_GoodsOutward", "so_gow_GetDataForPrintPickSlip", obj).subscribe(
        response => {
          this.PickAwaySlipData = response;

          for (const item of this.PickAwaySlipData) {
            item.ProductData = null;
            if (item.ProductDataList != null) {
              item.ProductData = JSON.parse(item.ProductDataList);
            }
          }

          resolve();
        },
        err => {
          reject(err);
        }
      );
    });
  }

  private PrintCombinedHtml(printHtml: string) {
    const $iframe: any = $("<iframe id='frame1'>").appendTo("body");

    const printDiv =
      "<style type='text/css' media='print'>" +
      "body { zoom: 90%; } " +
      "@page { size: A4; margin: 0.635cm; }" +
      "</style>" +
      "<html><head><title></title></head><body>" +
      printHtml +
      "</body></html>";

    const win = $iframe[0].contentWindow || $iframe[0];

    $(win.document).ready(function () {
      setTimeout(() => {
        win.window.print();

        setTimeout(() => {
          $iframe.remove();
        }, 1000);
      }, 300);
    });

    $iframe.contents().find("body").html(printDiv);
  }

  private waitForHtmlRender(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getBankAccountNumbers(bankDetails: any[]): string {
    if (!bankDetails || !bankDetails.length) {
      return '';
    }

    return bankDetails
      .map(x => x.AccountNumber)
      .filter(x => x)
      .join(', ');
  }

  SystemAWBPrintData: any = [];
  Print_SystemAWBPrint() {
    this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
    Helpers.setLoading(true);
    var obj: any = {};
    obj.userId = this.ParentUserId;
    obj.orderId = null;
    obj.MultiOrderId = this.OrderId;
    obj.companyId = this.CompanyId;
    this._appService.Post("so_GoodsOutward", "GetOutwardPackageListData", obj).subscribe(
      (response) => {
        this.SystemAWBPrintData = response.Table;

        for (const item of this.SystemAWBPrintData) {
          item.InvoiceDetails = null;
          if (item.OrderProductList != null) {
            item.InvoiceDetails = JSON.parse(item.OrderProductList);
            
            const sortedData = [...(item.InvoiceDetails || [])].sort(
              (a: any, b: any) => (a.RowOrder || 0) - (b.RowOrder || 0)
            );
            item.InvoiceDetails = sortedData;

            item.totalQty = 0;
            item.totalInvoiceAmount = 0;
            item.totalProductQty = 0;
            item.totalFinalAmount = 0;
            item.grandTotalAmount = 0;
            for (const ele of item.InvoiceDetails) {
              item.totalQty = item.totalQty + ele.Qty;
              ele.Qty = parseFloat(ele.Qty).toFixed(2);
              item.totalInvoiceAmount = (Number(item.totalInvoiceAmount) || 0) + (Number(ele.InvoiceAmount) || 0);
              item.totalFinalAmount = (Number(item.totalFinalAmount) || 0) + (Number(ele.FinalAmount) || 0);
            }
            item.totalQty = parseFloat(item.totalQty).toFixed(2);
            item.totalProductQty = parseFloat(item.totalQty).toFixed(0);
            item.totalInvoiceAmount = parseFloat(item.totalInvoiceAmount).toFixed(2);
            item.totalFinalAmount = Math.round(parseFloat(item.totalFinalAmount)).toFixed(2);
            // item.totalFinalAmount = (
            //                         parseFloat(item.totalFinalAmount) - 
            //                         parseFloat(item.SalesDiscount) + 
            //                         parseFloat(item.ShippingPrice) - 
            //                         parseFloat(item.totalDiscount)
            //                       ).toFixed(2);

            // item.totalFinalAmount = (
            //   Number(item.totalFinalAmount) -
            //   (Number(item.SalesDiscount) || 0) +
            //   (Number(item.ShippingPrice) || 0) -
            //   (Number(item.totalDiscount) || 0)
            // ).toFixed(2);

            item.totalFinalAmount = (
              Number(item.totalFinalAmount) -
              (Number(item.SalesDiscount) || 0) -
              (Number(item.totalDiscount) || 0)
            ).toFixed(2);

            item.grandTotalAmount = (Number(item.totalFinalAmount) || 0) + (Number(item.ShippingPrice) || 0);

            const productSum = item.InvoiceDetails.reduce(
              (sum, ele) => sum + (Number(ele.FinalAmount) || 0),
              0
            );

            const difference = Number(item.totalFinalAmount) - productSum;
            
            if (item.InvoiceDetails.length > 0) {
              const lastItem = item.InvoiceDetails[item.InvoiceDetails.length - 1];
              lastItem.FinalAmount = (
                (Number(lastItem.FinalAmount) || 0) + difference
              ).toFixed(2);
            }
          }
        }
        setTimeout(() => {
          var divElements = document.getElementById("System_AWB_label");
          this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
          console.log('System_AWB_Lable',divElements.innerHTML);
          var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
          // var printDiv =
          //   "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: 4in 6in;  margin: 0; }</style><html ><head><title></title></head><body>" +
          //   divElements.innerHTML +
          //   "</body></html>";
          var printDiv = "<style type='text/css' media='print'>@page { size: auto;  margin: 0mm; } @media print {@page {size: 4in 6in;}}</style><html><head><title></title></head><body>" 
          + divElements.innerHTML + "</body></html>"
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 1000);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          Helpers.setLoading(false);
        }, 300);

        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  PickSummaryData: any = [];
  PrintPickSummary() {
    this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
    Helpers.setLoading(true);
    var obj: any = {};
    obj.user_id = this.ParentUserId;
    obj.order_id = this.OrderId;
    this._appService.Post("so_GoodsOutward", "GetOutwardPickSummaryData", obj).subscribe(
      (response) => {
        if (
          response == null ||
          !Array.isArray(response) ||
          response.length === 0
        ) {
          this.PickSummaryData = [];
          Helpers.setLoading(false);
          this.toastr.warning("No pick summary data found to print.", "Warning");
          return;
        }


        this.PickSummaryData = response;

        for (const item of this.PickSummaryData) {
          item.ProductData = null;
          if (item.ProductDataList != null) {
            item.ProductData = JSON.parse(item.ProductDataList);
          }
        }

        setTimeout(() => {
          var divElements = document.getElementById("Outward_PrintSummaryPickSlip");
          this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
          var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
          var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
          console.log('Outward_PrintSummaryPickSlip',divElements.innerHTML);
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 1000);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          Helpers.setLoading(false);
        }, 300);

        Helpers.setLoading(false);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  PrintPickSummaryDownLoad() {
    this.currentDateTime = this.datepipe.transform(new Date(), "dd-MMM-yyyy HH:mm");
    Helpers.setLoading(true);
    var obj: any = {};
    obj.user_id = this.ParentUserId;
    obj.order_id = this.OrderId;
    this._appService.Post("so_GoodsOutward", "GetOutwardPickSummaryData", obj).subscribe(
      (response) => {
        this.PickSummaryData = response;

        for (const item of this.PickSummaryData) {
          item.ProductData = null;
          if (item.ProductDataList != null) {
            item.ProductData = JSON.parse(item.ProductDataList);
          }
        }

        setTimeout(() => {
        var divElements = document.getElementById("Outward_PrintSummaryPickSlip");

         var printDiv =
            "<style type='text/css' media='print'>body {zoom: 90%;} @page { size: A4;  margin: 0.635cm; }</style><html ><head><title></title></head><body>" +
            divElements.innerHTML +
            "</body></html>";
  
        var obj: any = {};
        obj.HtmlData = divElements.innerHTML;
  
                
                // Authorization Header
        const headers = new Headers();

        const userAccessToken = this.decryptpipe.transform(
          JSON.parse(this.cookieService.get("user_access_token"))
        );

        headers.append("Authorization", "Bearer " + userAccessToken);

        const options = new RequestOptions({
          headers: headers,
          responseType: ResponseContentType.Blob
        });

        const apiUrl = environment.apiUrl + '/api/OrdersByVehicle/DownloadPickSummaryPDF';

        this.anghttp.post(apiUrl, obj, options).subscribe(
          (response: Response) => {

            const pdfBlob = response.blob();

            if (!pdfBlob || pdfBlob.size === 0) {
              this.toastr.error('Generated PDF is empty.', 'error');
              Helpers.setLoading(false);
              return;
            }

            const pdfFile = new File(
              [pdfBlob],
              "Outward_Pick_Summary.pdf",
              {
                type: 'application/pdf',
                lastModified: new Date().getTime()
              }
            );

            // Download file
            const fileURL = window.URL.createObjectURL(pdfFile);

            const link = document.createElement('a');
            link.href = fileURL;
            link.download = pdfFile.name;
            link.click();

            window.URL.revokeObjectURL(fileURL);

            Helpers.setLoading(false);
          },
          (error) => {
            console.log(error);
            this.toastr.error('Error while downloading PDF', 'error');
            Helpers.setLoading(false);
          }
        );

        // this._appService.Post("OrdersByVehicle", "DownloadPickSummaryPDF", obj).subscribe(
        //   (response) => {
        //     this.DownloadFile(response)
        //     Helpers.setLoading(false);
        //   },
        //   (err) => {
        //     this.toastr.error("error while download", "error");
        //     Helpers.setLoading(false);
        //   }
        // );
        }, 1000);
      },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  PrintTripSheet() {
    Helpers.setLoading(true);
    this._appService.GetById("Booking", "GetTripSheet", this.BookingId).subscribe(
      (response) => {
        if (!response || !response.Table || response.Table.length === 0) {
          Helpers.setLoading(false);
          return;
        }

        this.PrintGateInPass = response.Table[0];
        this.PrintGateInPass.ConsignmentDetailList = response.Table1 || [];

        this.PrintGateInPass.TotalWeight = 0;
        this.PrintGateInPass.TotalQty = 0;
        this.PrintGateInPass.TotalAmountValue = 0;

        this.PrintGateInPass.ConsignmentDetailList.forEach((element) => {
          const totalQty = Number(element.Quantity) || 0;
          const totalWeight = Number(element.GrossWeight) || 0;
          const totalAmountValue = parseFloat(element.InvoiceAmount) || 0;

          this.PrintGateInPass.TotalQty += totalQty;
          this.PrintGateInPass.TotalWeight += totalWeight;
          this.PrintGateInPass.TotalAmountValue += totalAmountValue;
        });

        this.PrintGateInPass.TotalWeight = parseFloat(this.PrintGateInPass.TotalWeight.toFixed(2));
        Helpers.setLoading(false);

        setTimeout(() => {
          var divElements = document.getElementById("New_Print_TripSheet");
          var $iframe: any = $("<iframe id='frame'>").appendTo("body");
          var printDiv = divElements.innerHTML;
          console.log('PrintTripSheet.innerHTML:', divElements.innerHTML);
          var win = $iframe[0].contentWindow || $iframe[0];
          $(win.document).ready(function () {
            setTimeout(() => {
              win.window.print();
              setTimeout(() => {
                $iframe.remove();
              }, 500);
            });
          });
          $iframe.contents().find("body").html(printDiv);
          $("#PrintInvoice").val("");
          Helpers.setLoading(false);
        }, 1000);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("An error occured  !", "Error");
      }
    );
  }

  PrintTruckHireChallanwithCost(){
    this._appService.GetByTwoId("Booking","thc_getBasicDataForTHCPrint",this.BookingId,this.ConsingmentDetailsId).subscribe(
        (responseTHC) => {
          this.PrintGateInPass = {};
          this.PrintGateInPass = responseTHC[0];
          let resTHCCHargeListObj: any = [];
          if (
            responseTHC[0].THCChargeList != null &&
            responseTHC[0].THCChargeList != ""
          ) {
            resTHCCHargeListObj = JSON.parse(responseTHC[0].THCChargeList);
          }
          this.PrintGateInPass.TotalTruckHireCharge = 0;
          resTHCCHargeListObj.forEach((element:any) => {
            this.PrintGateInPass.TotalTruckHireCharge = this.PrintGateInPass.TotalTruckHireCharge + element.Amount;
          });
          this.PrintGateInPass.THCChargeList = resTHCCHargeListObj;

          this._appService.GetById("BookingOrigin","getConsignmentDetailList",this.ConsingmentDetailsId)
            .subscribe(
              (response) => {
                this.ConsignmentsData = [];
                this.ConsignmentsData.push(...(response as any));
                this.PrintGateInPass.ConsignmentDetailList = this.ConsignmentsData;

                this.PrintGateInPass.TotalCharge = 0;
                this.PrintGateInPass.TotalWeight = 0;
                this.PrintGateInPass.TotalQty = 0;
                this.PrintGateInPass.TotalValue = 0;
                this.PrintGateInPass.ConsignmentDetailList.forEach(
                  (element:any) => {
                    var TotalQty = 0;
                    var TotalWeight = 0;
                    var TotalValue = 0;
                    element.ProductDetail.forEach((element:any) => {
                      TotalQty = TotalQty + element.Quantity;
                      TotalWeight = TotalWeight + element.GrossWeight;
                      TotalValue = TotalValue + element.Value;
                    });

                    element.TotalQty = TotalQty;
                    element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
                    element.TotalValue = TotalValue;

                    this.PrintGateInPass.TotalWeight += element.TotalWeight;
                    this.PrintGateInPass.TotalQty += element.TotalQty;
                    this.PrintGateInPass.TotalValue += element.TotalValue;
                  }
                );
                
                this.PrintGateInPass.TotalWeight = parseFloat(this.PrintGateInPass.TotalWeight.toFixed(2));

                // let i = 0;
                // setTimeout(() => {
                //   this.PrintGateInPass.ConsignmentDetailList.forEach(
                //     (element:any) => {
                //       if (element.IsDoorDelivery == true) {
                //         $("#PrintDoorDelivery_" + i).attr(
                //           "checked",
                //           true
                //         );
                //       } else {
                //         $("#PrintDoorDelivery_" + i).attr(
                //           "checked",
                //           false
                //         );
                //       }

                //       if (element.IsUnloadedByParty == true) {
                //         $("#PrintUnloadedByParty_" + i).attr(
                //           "checked",
                //           true
                //         );
                //       } else {
                //         $("#PrintUnloadedByParty_" + i).attr(
                //           "checked",
                //           false
                //         );
                //       }
                //       i++;
                //     }
                //   );
                // }, 200);

                setTimeout(() => {
                  var divElements = document.getElementById("NEW_Print_Truck_Hire_Challan_with_Cost");
                  var $iframe: any = $("<iframe id='frame1'>").appendTo("body");
                  var printDiv =
                    "<html><head><title> Truck Hire Challan </title></head><body>" +
                    divElements.innerHTML +
                    "</body></html>";
                  console.log('Outward_PrintSummaryPickSlip',divElements.innerHTML);
                  var win = $iframe[0].contentWindow || $iframe[0];
                  $(win.document).ready(function () {
                    setTimeout(() => {
                      win.window.print();
                      setTimeout(() => {
                        $iframe.remove();
                      }, 1000);
                    });
                  });
                  $iframe.contents().find("body").html(printDiv);
                  Helpers.setLoading(false);
                }, 500);
                Helpers.setLoading(false);
              },
              (err) => {
                Helpers.setLoading(false);
                this.toastr.error(err._body.replace(/"/g, ""),"error");
              }
            );
        },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "error");
        }
      );
  }
}
